import * as React from "react";
import { preventEvent } from "../../core/utils/handleEvents";
import { APINames } from "../../legacy/api/api.names";
import { IButtonEvents } from "../_common/buttonEvents";
import { SpinIcon, StopIcon } from "./components/Icons";
import { Wrapper } from "./components/Wrapper";

export interface ISpinButton extends IButtonEvents {
  disabled?: boolean;
  spinStarted?: boolean;
}

export type SpinButtonEvents =
  | "spinbutton.click"
  | "spinbutton.disabled"
  | "spinbutton.value"
  | "spinbutton.enter"
  | "spinbutton.leave";

export class SpinButton extends React.PureComponent<ISpinButton> {
  public state = {
    touchTarget: null
  };

  public onClickHandler = (event: MouseEvent) => {
    this.setState({
      ...this.state
    });

    // prevent the click event
    event.preventDefault();
    event.stopPropagation();
  };

  public onTouchStartHandler = (event: TouchEvent) => {
    // save the element we are touching in the touchstart event
    const touch: Touch = event.changedTouches[0];
    const element: Element = document.elementFromPoint(
      touch.clientX,
      touch.clientY
    );

    this.setState({
      ...this.state,
      touchTarget: element
    });
  };

  public onTouchEndHandler = (event: TouchEvent) => {
    const { touchTarget } = this.state;

    // compare the element we are touching with the element
    // touched in the touchstart event
    const touch: Touch = event.changedTouches[0];
    const element: Element = document.elementFromPoint(
      touch.clientX,
      touch.clientY
    );

    if (touchTarget === element) {
      // if is the same, then simulate a click in the button
      // so we unify the API event dispatching
      const click: MouseEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
      });
      event.currentTarget.dispatchEvent(click);
    }

    // stop the event, so we don't get a double call to the click event
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      ...this.state,
      touchTarget: null
    });
  };

  public render() {
    const { spinStarted } = this.props;

    return (
      <Wrapper
        apiName={APINames.SPIN_BUTTON}
        {...this.props}
        onClick={this.onClickHandler}
        onTouchStart={this.onTouchStartHandler}
        onTouchEnd={this.onTouchEndHandler}
        onDragStart={preventEvent}
        data-spin-started={spinStarted}
      >
        <SpinIcon type="spin" />
        <StopIcon type="stop" />
      </Wrapper>
    );
  }
}
